<template>
  <div>
    <div class="row offset-1">
      <div class="col-md-5">
        <h3 class="text-muted text-center">Venta Año Anterior {{datos[0].anio_anterior}}</h3>
      </div>
      <div class="col-md-5">
        <h3 class="text-muted text-center">Venta Año Actual {{datos[0].anio}}</h3>
      </div>
    </div>
    <div class="row offset-1">
      <div class="col-md-5">
        <vuestic-chart type="pie" :data="donutDataVentaAnioAnterior()"/>
      </div>
      <div class="col-md-5">
        <vuestic-chart type="pie" :data="donutDataVentaActual()"/>
      </div>
    </div>
<!--    <div class="row offset-1">-->
<!--      <div class="col-md-5">-->
<!--        <h3 class="text-muted text-center">{{porcentaje()}}</h3>-->
<!--      </div>-->
<!--      <div class="col-md-5">-->
<!--        <h3 class="text-muted text-center">Venta Anio Actual {{datos[0].anio}}</h3>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>

  //TODO COLOCAR PORCENTAJE DE CUANTO LE PERTENECE A CADA UNO
  import VuesticChart from "../../../vuestic-theme/vuestic-components/vuestic-chart/VuesticChart";

  export default {
    name: "donutComponent",
    components: {VuesticChart},
    props: ["datos"],
    methods: {
      donutDataVentaActual() {
        const sucursal = this.datos.length >= 1 ? this.datos.map(item => this.$store.getters.sucursal(item.sucursal_id).nombre) : []
        return {
          labels: sucursal,
          datasets: [
            {
              label: "VENTA AÑO ACTUAL",
              backgroundColor: this.paleta(sucursal),
              data: this.datos.length >= 1 ? this.datos.map(item => item.venta_actual) : []
            }
          ]
        }
      },
      donutDataVentaAnioAnterior() {
        const sucursal = this.datos.length >= 1 ? this.datos.map(item => this.$store.getters.sucursal(item.sucursal_id).nombre) : []
        return {
          labels: sucursal,
          datasets: [
            {
              label: "VENTA AÑO ANTERIOR",
              backgroundColor: this.paleta(sucursal),
              data: this.datos.length >= 1 ? this.datos.map(item => item.venta_anio_anterior) : []
            }
          ]
        }
      },
      paleta(sucursal) {
        let paleta = []
        sucursal.forEach(item => {
          if (item.toLowerCase() === "coquimbo")
            paleta.push("#f4fc00")
          if (item.toLowerCase() === "la serena")
            paleta.push("#c40000")
          if (item.toLowerCase() === "andacollo")
            paleta.push("#364eff")
          if (item.toLowerCase() === "web")
            paleta.push("#00fed0")
        })
        return paleta
      }
    }
  }
</script>

<style scoped>

</style>
